module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_oslo_viken_pos.4b0d5c96.pdf";